import { useQuery } from "@tanstack/react-query";
import { noBarData, noData, type PerformanceWithAccountFilter } from "features/Library/Common/utils/performanceUtils";
import { reportingColors } from "features/Library/Common/utils/constants";
import { ChartWrapper, HorizontalBarChart } from "components/charts";
import { RequestStatusRenderer } from "components/requestStatsRenderer/RequestStatusRenderer";
import CardReporting from "components/cards/CardReporting/CardReporting";
import { sharedAccountReportingHorizontalBarProps } from "features/Reporting/Content/shared";
import { getTemplateEmailEngagement } from "./queries";
import styles from "./templateEmailEngagement.module.scss";
import { type DataPoint } from "components/charts/types/HorizontalBarChart";

export interface TemplateEmailEngagementProps {
  templateId: number;
  filter: PerformanceWithAccountFilter;
}

export const TemplateEmailEngagement: React.FC<TemplateEmailEngagementProps> = ({ templateId, filter }) => {
  const emailEngagementQuery = useQuery({
    queryKey: ["templateEmailEngagementCards", templateId, filter],
    queryFn: getTemplateEmailEngagement,
    enabled: filter.type !== undefined,
  });

  return (
    <div className={styles.contentReport}>
      <div className={styles.activity}>
        <ChartWrapper
          titles={["Email Engagement"]}
          legendLabels={["Sends", "Opens", "Clicks"]}
          showLegend
          colorRange={[reportingColors.blue, reportingColors.greenDark, reportingColors.yellow]}
        >
          <RequestStatusRenderer state={emailEngagementQuery.status}>
            {emailEngagementQuery.isSuccess &&
            emailEngagementQuery.data &&
            !noBarData(...emailEngagementQuery.data.barData.map((d: DataPoint) => d.value)) ? (
              <HorizontalBarChart
                {...sharedAccountReportingHorizontalBarProps}
                data={emailEngagementQuery.data.barData}
              />
            ) : (
              noData(filter)
            )}
          </RequestStatusRenderer>
        </ChartWrapper>
      </div>
      <div className={styles.cards}>
        <RequestStatusRenderer state={emailEngagementQuery.status}>
          {emailEngagementQuery.isSuccess && emailEngagementQuery.data && (
            <CardReporting items={emailEngagementQuery.data.cards} />
          )}
        </RequestStatusRenderer>
      </div>
    </div>
  );
};

export default TemplateEmailEngagement;
